import { render, staticRenderFns } from "./AdminTicketNewAnswerForm.vue?vue&type=template&id=5703b642&"
import script from "./AdminTicketNewAnswerForm.vue?vue&type=script&lang=ts&"
export * from "./AdminTicketNewAnswerForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QSpinnerDots from 'quasar/src/components/spinner/QSpinnerDots.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSpinnerDots});
